import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { getOrgId } from '../fvid-auth/userSession';

export interface IContactMetaAllowedValues {
  name: string;
  value: number;
}

export interface IContactsMeta {
  fieldName: string;
  selector: string;
  action: string;
  value: string;
  allowedValues: IContactMetaAllowedValues[];
  defaultValue: boolean;
  tab: { id: string; title: string; };
  fieldSet: { id: string; title: string };
  limitByPersonType: number[];
  examples: { selector: string; action: string; value: string; }[];
}

/**
 * TanStack Query version of useQueryContactsMeta
 * Fetches contacts metadata using HTTP client
 */
const useQueryContactsMeta = () => {
  const httpClient = useHttpClient();
  const orgId = getOrgId();

  return useQuery<IContactsMeta[]>({
    queryKey: ['contactsMeta', orgId],
    queryFn: async () => {
      const response = await httpClient.get('/custom-contacts-meta');
      return response.data.items || response.data;
    },
    enabled: !!orgId, // Only fetch when orgId is available
  });
};

export default useQueryContactsMeta;
